import classes from './BannerHero.module.scss';
import Image from 'next/image';
import DownloadCtaCard from '../../organisms/downloadCtaCard/DownloadCtaCard';
import { useCheckLanguage } from '../../../utils/useCheckLanguage';

export default function BannerHero(props) {
    const arabic = useCheckLanguage();

    /**
     * return null needed for react render func
     */
    if (!props) return null;

    const { hasBackgroundColorBlobs, overlayState } = props;
    const directDownload = props[0];
    const siteImage = props[1];
    const siteContent = props[2];

    return (
        <div className={classes.oBlockBannerHero}>
            <div className={`container`}>
                {siteContent ? (
                    <div className={`row`}>
                        <h2 className={`${classes.aTitle} ${classes[arabic]} aH2 fnt-mb`}>
                            {siteContent.site_header}
                        </h2>
                        <p className={`${classes.aDescription} ${classes[arabic]} fnt24`}>
                            {siteContent.site_description}
                        </p>
                    </div>
                ) : null}
                <div className={`row`}>
                    <div className={classes.oWidgetBlock}>
                        <DownloadCtaCard
                            {...directDownload}
                            overlayState={overlayState}
                            arabic={arabic}
                        />
                    </div>
                </div>
            </div>
            <figure className={classes.aHeroBannerOverlay}>
                <Image
                    src={siteImage?.image?.data?.attributes?.url}
                    alt={`hero-banner`}
                    width={siteImage?.image?.data?.attributes?.width}
                    height={siteImage?.image?.data?.attributes?.height}
                    className={classes.aImage}
                    aria-hidden="true"
                    layout="responsive"
                    priority={true}
                />
            </figure>
            {hasBackgroundColorBlobs ? (
                <div className={classes.oBackgroundBlock}>
                    <svg
                        className={classes.aBgSvgBeanLeft}
                        width="470"
                        height="512"
                        viewBox="0 0 470 512"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            d="M341 502.793C479.894 460.52 486.154 327.71 453.361 235.153C430.009 169.239 309.668 12.9394 137.433 -27.6841C-34.8008 -68.3078 -16.7254 -28.0911 -16.7254 -28.0911C-59.1518 5.85002 -89.8856 -83.8106 -147.5 51.4995C-219.518 220.637 -273.892 304.514 -123.325 414.87C-32.5972 481.368 80.1663 404.668 163.586 452.034C247.006 499.4 261.349 527.036 341 502.793Z"
                            fill="#FDB933"
                            fillOpacity="0.8"
                        />
                    </svg>
                    <span className={`${classes.aBgCircle} ${classes.Purple1}`} />
                    <span className={`${classes.aBgCircle} ${classes.Purple2}`} />
                    <span className={`${classes.aBgCircle} ${classes.Orange1}`} />
                    <span className={`${classes.aBgCircle} ${classes.Orange2}`} />
                    <span className={`${classes.aBgCircle} ${classes.Red1}`} />
                    <span className={`${classes.aBgCircle} ${classes.Red2}`} />
                    <span className={`${classes.aBgCircle} ${classes.Green1}`} />
                    <span className={`${classes.aBgCircle} ${classes.Green2}`} />
                </div>
            ) : (
                <div className={classes.oBackgroundBlock}>
                    <svg
                        className={classes.aBgSvgBeanLeft}
                        width="470"
                        height="512"
                        viewBox="0 0 470 512"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            d="M341 502.793C479.894 460.52 486.154 327.71 453.361 235.153C430.009 169.239 309.668 12.9394 137.433 -27.6841C-34.8008 -68.3078 -16.7254 -28.0911 -16.7254 -28.0911C-59.1518 5.85002 -89.8856 -83.8106 -147.5 51.4995C-219.518 220.637 -273.892 304.514 -123.325 414.87C-32.5972 481.368 80.1663 404.668 163.586 452.034C247.006 499.4 261.349 527.036 341 502.793Z"
                            fill="#FDB933"
                            fillOpacity="0.8"
                        />
                    </svg>
                </div>
            )}
        </div>
    );
}
